export default "__VITE_ASSET__CsTUaiIe__"